import * as _ from 'underscore';
import * as chartjs from 'chart.js';

export class ChartModel {
	public data: KnockoutObservable<chartjs.ChartData>;
	public options: KnockoutObservable<chartjs.ChartConfiguration>;
	public instance: Chart;
	public hasData: KnockoutComputed<boolean>;

	constructor(options: chartjs.ChartConfiguration, data?: chartjs.ChartData) {
		this.options = ko.observable(options);
		this.data = ko.observable(data);
		this.instance = null;

		this.hasData = ko.pureComputed(() => {
			let _data: chartjs.ChartData = this.data();
			return (
				_data !== undefined &&
				_data != null &&
				_data.datasets !== undefined &&
				_data.datasets !== null &&
				_data.datasets.length > 0 &&
				_.some(_data.datasets, (dataset: chartjs.ChartDataSets) => {
					return dataset.data.length > 0;
				})
			);
		});
	}

	public setData(data: chartjs.ChartData) {
		this.data(data);
	}
}
